import { BE_URLS } from "@/constants/config.js";
import axios from "@/api/axios/axios_core_deal.js";

const DEAL_HOST = BE_URLS.BACKEND_DEAL_SERVER_URL;

// ─── Telnyx Provider ─────────────────────────────────────────────────────

export function saveTelnyxProvider(data) {
  return axios.post(`${DEAL_HOST}/telnyx-provider`, data);
}

export function getTelnyxProvider() {
  return axios.get(`${DEAL_HOST}/telnyx-provider`);
}

export function testTelnyxConnection() {
  return axios.post(`${DEAL_HOST}/telnyx-provider/test-connection`);
}

export function deleteTelnyxProvider() {
  return axios.delete(`${DEAL_HOST}/telnyx-provider`);
}

// ─── Phone Numbers ───────────────────────────────────────────────────────

export function searchPhoneNumbers(params) {
  return axios.get(`${DEAL_HOST}/phone-numbers/search`, { params });
}

export function provisionPhoneNumber(data) {
  return axios.post(`${DEAL_HOST}/phone-numbers/provision`, data);
}

export function getPhoneNumbers(params) {
  return axios.get(`${DEAL_HOST}/phone-numbers`, { params });
}

export function releasePhoneNumber(numberId) {
  return axios.delete(`${DEAL_HOST}/phone-numbers/${numberId}`);
}

// ─── Fax ─────────────────────────────────────────────────────────────────

export function sendFax(data) {
  return axios.post(`${DEAL_HOST}/fax/send`, data);
}

export function getFaxHistory(params) {
  return axios.get(`${DEAL_HOST}/fax/history`, { params });
}

export function getFax(faxId) {
  return axios.get(`${DEAL_HOST}/fax/${faxId}`);
}
